import React, { useState } from "react";
import { NavigationLink } from "./NavigationLink";
import { LinkAreaViewModel } from "../../../Model/Blocks/NotAvailableForEdit/LinkAreaViewModel.csharp";
import { NavigationItemViewModel } from "../TopBar/NavigationItemViewModel.csharp";

interface MobileNavigationProps {
  navigationItems: NavigationItemViewModel[];
}

export const MobileNavigation: React.FC<MobileNavigationProps> = ({
  navigationItems,
}) => {
  const [currentStep, setCurrentStep] = useState(1);

  const [currentNavigationItem, setCurrentNavigationItem] =
    useState<NavigationItemViewModel>();

  const [currentNavigationSection, setCurrentNavigationSection] =
    useState<LinkAreaViewModel>();

  const goToFirstStep = () => {
    setCurrentStep(1);
  };

  const goToSecondStep = (item: NavigationItemViewModel) => {
    setCurrentNavigationItem(item);
    setCurrentStep(2);
  };

  const goToThirdStep = (item: LinkAreaViewModel) => {
    setCurrentNavigationSection(item);
    setCurrentStep(3);
  };

  return (
    <div
      className={`d-flex megamenu-slide ${
        currentStep === 2
          ? "megamenu-slide__2"
          : currentStep === 3
          ? "megamenu-slide__3"
          : ""
      }`}
    >
      <div className="megamenu-mobile__step py-3 px-2">
        <ul className="link-list link-list--arrow fw-normal">
          {navigationItems.map((item, i) => (
            <li key={i}>
              {item.linkSections.length != 0 && (
                <button
                  className="btn btn-link"
                  onClick={() => goToSecondStep(item)}
                >
                  {item.heading.title}
                </button>
              )}
              {item.linkSections.length == 0 && (
                <a className="no-arrow disable-hover" href={item.heading.url}>
                  {item.heading.title}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className="megamenu-mobile__step py-3 px-2">
        <button
          className="btn btn-link link-back d-md-none mt-n3 py-1"
          onClick={() => goToFirstStep()}
        >
          Tilbake til hovedmeny
        </button>

        <h3 className="h5 pt-2 pb-1">
          <a href={currentNavigationItem?.heading.url}>
            {currentNavigationItem?.heading.title}
          </a>
        </h3>

        <ul className="link-list link-list--arrow fw-normal">
          {currentNavigationItem?.linkSections.map((section, index) => (
            <li key={index}>
              {section.links.length > 0 && (
                <button
                  className="btn btn-link"
                  onClick={() => goToThirdStep(section)}
                >
                  {section.heading.title}
                </button>
              )}
              {section.links.length == 0 && (
                <NavigationLink className="no-arrow disable-hover" link={section.heading} />
              )}
            </li>
          ))}

          {currentNavigationItem?.additionalLink && (
            <li>
              <NavigationLink
                className="no-arrow disable-hover"
                link={currentNavigationItem.additionalLink}
              />
            </li>
          )}
        </ul>
      </div>

      <div className="megamenu-mobile__step py-3 px-2">
        <button
          className="btn btn-link link-back d-md-none mt-n3 py-1"
          onClick={() => goToSecondStep(currentNavigationItem!)}
        >
          <span className="visually-hidden">Tilbake til </span>
          {currentNavigationItem?.heading.title}
        </button>

        <h3 className="h5 py-2 mb-0">
          {currentNavigationSection?.heading && (
            <NavigationLink
              className="p-0"
              link={currentNavigationSection.heading}
            />
          )}
        </h3>

        <ul className="link-list link-list--bare-bones pt-1">
          {currentNavigationSection?.links.map((link, index) => (
            <li className="m-0" key={index}>
              <NavigationLink
                className="d-inline-block py-1 px-0 no-underline"
                link={link}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
